import { store } from '../store';

export const getAuthorizationHeader = (): string => {
    const token = store.getState().authReducer.token;

    return token ? `Bearer ${token}` : '';
};
